export default __webpack_public_path__ + "static/beian-0c5770666939ca0a3bbdb0daa3e68cc2.png";